const IframePreview = ({node}) => {
  const {url} = node;
  return (
    <div className="relative my-2">
      <iframe src={url} width="100%" height="600"></iframe>
    </div>
  );
};

export default IframePreview;
